import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DevicesRoutingModule } from './devices-routing.module';
import { FiltersModule } from 'libs/portal/src/modules/tools/filters/filters.module';
import { CardTableModule } from 'libs/portal/src/modules/tools/card-table/card-table.module';
import { TimeAgoExtendsPipe } from 'libs/portal/src/modules/tools/pipes/time-ago.pipe';
import { LocationRadiusModalModule } from '../../components/location-radius-modal/location-radius-modal.module';
import { KeepAliveComponent } from './keep-alive/keep-alive.component';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { MatRowComponent } from '../../../tools/mat-row/mat-row.component';

@NgModule({
  declarations: [KeepAliveComponent],
  imports: [CommonModule, FormsModule, FiltersModule, CardTableModule, DevicesRoutingModule, LocationRadiusModalModule, MaterialModule, MatRowComponent],
  providers: [TimeAgoExtendsPipe],
})
export class DevicesModule {}
